import { render, staticRenderFns } from "./allotMember.vue?vue&type=template&id=5330749d&"
import script from "./allotMember.vue?vue&type=script&lang=js&"
export * from "./allotMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5330749d')) {
      api.createRecord('5330749d', component.options)
    } else {
      api.reload('5330749d', component.options)
    }
    module.hot.accept("./allotMember.vue?vue&type=template&id=5330749d&", function () {
      api.rerender('5330749d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/role/allotMember.vue"
export default component.exports